import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Spinner,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import "./ForgetPassword.css"; // Custom CSS for styling
import { Link } from "react-router-dom";
import ai_powered_cv_logo from "../../../assets/img/Ai-powered-cv-logo.png";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// Validation Schema
const validationSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
});

function ForgetPassword() {
  const notifySuccess = () =>
    toast.success("Password reset link sent successfully!");

  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      setSubmitting(true);
      try {
        await axios.post(
          `${BASE_URL}/api/users/forgot-password`,
          values
        );
        notifySuccess();
        resetForm();
      } catch (error) {
        toast.error(error.response?.data?.message || "Something went wrong.");
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <div className="forgot-password-container">
      <Container className="d-flex flex-column align-items-center justify-content-center ">
        <h1 className="text-white fw-bold mb-4">
            <Link to="/" className="text-decoration-none d-flex justify-content-center me-3 ">
                               <img 
                                 src={ ai_powered_cv_logo}
                                 alt="AI-Powered CV" 
                                 className="logo-img w-50"
                               />
                             </Link>
        </h1>

        <Row className="justify-content-center w-100">
          <Col md={6} lg={5}>
            <Card className="p-4 glassmorphism">
              <Card.Body>
                <h2 className="text-center mb-4 text-white">
                  Forgot Password?
                </h2>
                <p className="text-center text-white">
                  Enter your email, and we'll send you a link to reset your
                  password.
                </p>
                <Form onSubmit={formik.handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Enter Your Email"
                      {...formik.getFieldProps("email")}
                      isInvalid={formik.touched.email && formik.errors.email}
                      className="p-2"
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.email}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Button
                    type="submit"
                    className="w-100 btn-custom"
                    disabled={formik.isSubmitting}
                  >
                    {formik.isSubmitting ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      "Send Reset Link"
                    )}
                  </Button>

                  <div className="text-center mt-3">
                    <Link to="/login" className="text-white">
                      Back to Login
                    </Link>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <ToastContainer />
    </div>
  );
}

export default ForgetPassword;
